import { HeaderMiniCartDropMenu } from '@/components/content/Header/parts/MiniCartDropMenu';
import {
	headerMiniCartDrawerContainerSX,
	headerMiniCartDrawerHeaderIconSX,
	headerMiniCartDrawerHeaderSX,
	headerMiniCartDrawerHeaderTitleSX,
	headerMiniCartDrawerIconSX,
} from '@/components/content/Header/styles/miniCart/drawer';
import { useLocalization } from '@/data/Localization';
import { useSettings } from '@/data/Settings';
import CloseIcon from '@mui/icons-material/Close';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import {
	Box,
	Divider,
	Drawer,
	Fade,
	Stack,
	Typography,
	useMediaQuery,
	useTheme,
} from '@mui/material';
import { FC, useEffect } from 'react';

type Props = {
	idPaper: string;
	isOpen: boolean;
	onClose: () => void;
};

export const HeaderMiniCartDrawer: FC<Props> = ({ idPaper, isOpen, onClose }) => {
	const CartLabels = useLocalization('MiniCart');
	const { settings } = useSettings();
	const theme = useTheme();
	const isMobile = useMediaQuery(theme.breakpoints.down('lg'));
	const isMobileApp = settings.isMobileApp;

	useEffect(() => {
		onClose();
	}, [isMobile]);

	return (
		!isMobileApp && (
			<Fade
				in={isOpen}
				timeout={500}
				style={{
					transitionTimingFunction: isOpen ? 'ease-in' : 'ease-out',
				}}
			>
				<Box id="header-mini-cart-drawer">
					<Drawer
						open={isOpen}
						onClose={onClose}
						sx={headerMiniCartDrawerContainerSX}
						anchor="bottom"
						elevation={4}
						variant="temporary"
						PaperProps={{
							id: idPaper,
						}}
					>
						<Stack direction="row" justifyContent="space-between" sx={headerMiniCartDrawerHeaderSX}>
							<Stack direction="row" spacing={1}>
								<ShoppingCartIcon sx={headerMiniCartDrawerHeaderIconSX} />
								<Typography variant="body1" sx={headerMiniCartDrawerHeaderTitleSX}>
									{CartLabels.Title.t()}
								</Typography>
							</Stack>
							<CloseIcon
								sx={headerMiniCartDrawerIconSX}
								onClick={onClose}
								className="quick-cart__close"
							/>
						</Stack>
						<Divider />
						<HeaderMiniCartDropMenu drawerView />
					</Drawer>
				</Box>
			</Fade>
		)
	);
};
